// import { Component, OnInit } from '@angular/core';
import{MyJobCardsDetailsService} from './my-job-cards-details.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
// import { AspMyRequestService } from '../asp-my-request/asp-my-request.service';
import { Component, ViewChild, ViewContainerRef, ComponentFactoryResolver, OnInit } from '@angular/core';
import { AspRequestDetailsComponent } from '../asp-request-details/asp-request-details.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { AspVehicleServiceHistoryComponent } from '../asp-vehicle-service-history/asp-vehicle-service-history.component';
import { ChangeDetectorRef } from '@angular/core';
import { AspQuotationDetailsService } from 'app/main/customer/asp-quotation-details/asp-quotation-details.service';
import { GlobalVariable } from 'app/main/globals';
import { AspJobcardQuotationComponent } from '../asp-jobcard-quotation/asp-jobcard-quotation.component';
import { AspCheckinReportsService} from '../asp-checkin-reports/asp-checkin-reports.service';
import {AspRequestDetailsService} from '../asp-request-details/asp-request-details.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AspInvoiceDetailsComponent } from '../asp-invoice-details/asp-invoice-details.component';
import { Pipe, PipeTransform } from '@angular/core';
import { AspCustomerQuoteService } from '../asp-customer-quote/asp-customer-quote.service';
import { AspLoadingService } from '../asp-loading/asp-loading.service'; 
import { AspInvoiceDetailsService } from '../asp-invoice-details/asp-invoice-details.service';
import {SearchSuggestionService} from 'app/shared/search-suggestion.service'
import { AspProductDetailsService } from '../../auto-spare-parts/asp-product-details/asp-product-details.service';

interface FilterOption {
  label: string;
  value: string;
  checked: boolean;
  children?: FilterOption[];
}

interface Filters {
  jobCardStatus: FilterOption[];
}


@Component({
  selector: 'app-my-job-cards-details',
  templateUrl: './my-job-cards-details.component.html',
  styleUrls: ['./my-job-cards-details.component.scss']
})
export class MyJobCardsDetailsComponent implements OnInit {
  @ViewChild('myDynamicSec', { read: ViewContainerRef, static: true }) container: ViewContainerRef;
  @ViewChild('vehicleServiceHistoryContainer', { read: ViewContainerRef }) historyContainer!: ViewContainerRef;

  
  activeTab: string = 'quoteReceived';
  sidebarOpen: boolean = false;
  quotationReceived: any[] = [];
  quotationApproved: any[] = [];
  itemDetails: any;
  selectedItemsCount: number = 0;
  totalSelectedPrice: number = 0;
  request: any;
  jobCard: any; 
  booking: any;
  jobCardId: number | null = null;
  bookingId: number;
  viewContainerRef: any;
  isMobile: boolean;
  status: string = '';

  successIcon: any = '../../../../assets/icons/icons8-ok.gif';
  showServiceHistory: boolean;
  customer: any;
  car: any;
  openSideShow: boolean;
  PopupOpen: boolean;
  quoteDetails: any[];
  quote: any;
  items: unknown;
  data: any;
  jobCardStatus: number | null = null;  

  sidebarOpenInvoice: boolean;
  selectAllQuote: boolean;
  customerQuotation: any[]=[];
  customerQuotationPrice: number=0;
  totalSelectedPriceQuote: number=0;
  selectedItemsCountQuote: number=0;
  isSidebarOpen: boolean;
  searchWord: string = '';
  filteredItems: any[] = [];
  selectedItemsLabourQuote: any;
  selectedLaboursCount: any;
  quoteItemStatus: any;
  selectedApprovedItemsCount: number;
  totalApprovedSelectedPrice: any;
  totalSelectedApprovedPrice: any;
  customerquoteid: any;
  selectedLabourslength: number=0;
  selectedLabours: any;
  searchText: string;
  itemQuote: any[];
  isPopupOpenEdit: boolean;
  selectedLabourCount:any;
  sparePartsTotal: any;
  labourListData: any[];
  totallabourSelectedPrice: number=0;
  filteredItems1: any[];
  selectedItemsQuote: any[];
  quotationreceived: any;
  quotationapproved: any;
  quoteApprovedPrice: any;
  side1235: boolean;
  requestId: any;
  requestDetails: any;
  filteredOrderList: any[]=[];
  quoteReceivedPrice: number=0;
  isEditLabourSidebarOpen: boolean;
  selectedLabour: any;
  labourName: any;
  labourAmount: any;
  labourId: any;
  id: any;
  partNumber: any;
  selectAll: boolean = false; 
  isAddLabour: boolean;
  showSkipConfirmation: boolean;
  showCancelConfirmation: boolean;
  isPopupOpen: boolean;
  sidebarOpenQuote: boolean;
  unitPrice: any;
  laborDetails: any;
  totalSelectedPriceQuote1: any;
  selectedItems: any[];
  resData: any;
  dataid: any;
  item: any;
  itemLength: any;
  request1: any;
  selectedItemsLabourQuotePrice: any;
  selectedLabourLength: any;
  selectedItemsCount1: any;
  selectedItemsCountTotal: any;
  totalSelectedPriceQuoteTotal: any;
  showGstColumn: number;
 
  customerName: any;
  isOpen = false;
  invoiceOpenItem: string;
  onClose!: () => void;
  quoteGrandTotal: number = 0;
  totallabourListSelectedPrice: any;
  sparePartsTotalcreation: number;
  newItem: boolean;
  newItems: boolean;
  itemForm: UntypedFormGroup;
  originalData: any;

  gstOptions: number[] = [5, 12, 18, 28]; 
  labourQuotationPrice: number;
  itemQuotesEdit: any;
  fullLabourList: any;
  selectedNewLabours: number;
  totallabourListNewSelectedPrice: any;
  selectedNewLabourSelected: any[];
  customerQuotation1: any;
  gstDetails = false;
  hasGst: boolean = true;
  gstNumberform: UntypedFormGroup;
  gstNumber: string = "";
  showGstSecondSlider: boolean = false;
  showBusinessInfoSlider: boolean = false;
businessName: string = '';
showAddressSlider: boolean = false;
addressLine1: string = '';
addressLine2: string = '';
pincode: string = '';
city: string = '';
customerGstForm: UntypedFormGroup;
  addressForm: UntypedFormGroup;
  stateSliderOpen = false;
  selectedState: string = '';
  stateData: any[] = [];
  filteredStates: any[] = [];
  isGstDetailsPresent: any;
  showExtraDiscountBottomSheet = false;
  discountType: 'rupees' | 'percentage' | null;
  discountValue: number | null | 0.0;
  showInfoPopup: boolean = false;
  discountInRupees: number = 0;
  discountInPercent: number = 0;
  calculatedDiscount: number = 0;
  totalInvoicePrice: any;
  invoiceId: any;
  isDiscountInvalid: boolean;
   searchActive: boolean = false;
  itemSuggestions: any[] = [];
  showSuggestionList = false;
  suggestions: { value: string; type: string }[] = []; // Updated type
  selectedSuggestions: Set<string> = new Set<string>();
  isInputVisible = false;
  isSearchOpen = false;
  searchTimeout: any;
  selectedGst: number | null = null;
  rateCardApplicable: any;
  carSize: any;
  rateCardType: any;
   mainForm: UntypedFormGroup;
  quoteFormArray: UntypedFormArray;
  itemDiscountValue: any;
  itemDiscountType: any;

  constructor(
    public searchSuggestionService:SearchSuggestionService,
    private aspProductDetailsService: AspProductDetailsService,
    private myJobCardsDetailsService: MyJobCardsDetailsService,
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private aspInvoiceDetailsService : AspInvoiceDetailsService,
    
    private aspQuotationDetailsService:AspQuotationDetailsService,
    private _formBuilder: UntypedFormBuilder,
    // private aspMyRequestService: AspMyRequestService,
    private breakpointObserver: BreakpointObserver,
    private resolver: ComponentFactoryResolver,
    private AspCheckinReportsService:AspCheckinReportsService,
    // private router: Router
    private aspRequestDetailsService:AspRequestDetailsService,
    private toastr: ToastrService,
    private router:Router,
    private aspCustomerQuoteService:AspCustomerQuoteService,
    private aspLoadingService: AspLoadingService,
    private fb: UntypedFormBuilder,
    private aspCheckinReportsService: AspCheckinReportsService,
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); 
if (window.location.pathname === '/feedback') {
  this.router.navigate(['asp-feedback']);
}
this.itemForm = new UntypedFormGroup({
  itemName: new UntypedFormControl('', Validators.required),
  partNumber: new UntypedFormControl('', Validators.required),
  brand: new UntypedFormControl('', Validators.required),
  hsn: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]{4,8}$')]), // HSN validation (4-8 digits)
  gst: new UntypedFormControl('', Validators.required), // Dropdown selection required
  unitPrice: new UntypedFormControl('', [Validators.required, Validators.min(0)]) // Unit price must be > 0
});
this.customerGstForm = this._formBuilder.group({
  "businessName":['', [Validators.required, Validators.minLength(2)]],
  "gstNumber": [this.gstNumber,Validators.required,Validators.pattern(/^[0-9A-Z]{15}$/)]
,
  "address" : ['', [Validators.required, Validators.minLength(2)]], 
"state": [this.selectedState, Validators.required],

});

  this.addressForm = this._formBuilder.group({
    addressLine1: [''],
    addressLine2: [''], 
    pincode: [''],
    city: ['']
  });
  }

statusList = [
  {label: 'Rejected', value: '0', checked: false,statusclass: 'reject-status'},
  {label: 'Created', value: '1', checked: false,statusclass: 'createStatus'},
  { label: 'Quote Due', value: '2', checked: false, statusclass: 'quote-due'},
  { label: 'Approval Due', value: '3', checked: false, statusclass: 'approval-due'},
  { label: 'In Progress', value: '4', checked: false, statusclass: 'inprogress'},
  { label: 'Ready', value: '5', checked: false, statusclass: 'ready'},
  { label: 'Invoice Created', value: '6', checked: false, statusclass: 'invoice'},
  { label: 'Closed', value: '7', checked: false, statusclass: 'close-status'},
];
filters: Filters = {
  jobCardStatus: this.statusList,
}
get cgf() {
  return this.customerGstForm.controls;
}
get gst(){
  return this.gstNumberform.controls;
}
get af() {
  return this.addressForm.controls;
}
  ngOnInit(): void {
    this.invoiceOpenItem=localStorage.getItem('invoiceOpen');
    this.jobCardId = Number(this.route.snapshot.paramMap.get('id'));
    this.bookingId = Number(this.route.snapshot.paramMap.get('bookingId'));

    this.fetchJobCardDetails();
    // this.fetchMyRequest();
    this.laborDetails = this._formBuilder.group({
      labourName: ['', [Validators.required, Validators.minLength(2)]], 
      labourAmount: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });
    this.unitPrice=this._formBuilder.group({
      unitprice:['',[Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
    });
    
    this.checkInDetails();
    // this.fetchStates();

          this.quoteFormArray = this.fb.array([]);
    this.mainForm = this.fb.group({
      quoteFormArray: this.quoteFormArray
    });
  }
  get up() {
    return this.unitPrice.controls;
  }
    
    get ld() {
      return this.laborDetails.controls;
    }
  openMenu() {
    this.openSideShow = !this.openSideShow;
  }
  
  markReady() {
    // const itemsArray = Array.isArray(this.items) ? this.items : [this.items];
  
    // const hasValidStatus = itemsArray.some(item => item['jobCardStatus'] === 3 || item['jobCardStatus'] === 4);
  
  
    // if (hasValidStatus) {
      this.PopupOpen=true;
      // Perform your action here
    // } else {
    //   console.log("No items have jobCardStatus 3 or 4");
    // }
  }
  checkInDetails(){

    let userKey = localStorage.getItem('spareUserKey');
    let garageKey = localStorage.getItem('garageKey');
    this.AspCheckinReportsService.checkInDetails(garageKey, userKey, this.bookingId, this.jobCardId).subscribe(
      result => {
        
        const res = JSON.parse(JSON.stringify(result));
        this.data = res['data'];
        console.log("this.data-----",this.data);
        this.customerName=this.data.customerName;
        
      }
    );
  }
  
  shareDeails(){
    const message = `*📢 Car Service Update*

Dear ${this.data.customerName},

We are pleased to inform you that the service and repair of your car with *Registration Number ${this.data.registrationNumber}* have been successfully completed. 🚗✨

Your car is now ready for pickup from *${this.data.garageName}*.

📍 *Pickup Location*: ${this.data.garageAddress}
⏰ *Timings*: 9 AM - 7 PM

If you have any questions or need assistance, feel free to reach out to us.

Thank you for choosing us for your car’s care! 😊

*Warm regards,*  
*Team ${this.data.garageName}* `
      
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');


  //    const carDetails = `${this.request?.jobCard?.make} ${this.request?.jobCard?.model} - ${this.request?.jobCard?.fuelType} - ${this.request?.jobCard?.variant} - ${this.request?.jobCard?.year}`;
  //   const messagePayload = {
  //   v1: this.data.garageName,                        // garage name
  //   v2: String(this.jobCardId),                                   // job card id
  //   v3: carDetails,                                   
  //   v4: this.request?.jobCard?.registrationNumber,               
  //   v5: '', 
  //   id: '',
  //   to: String(this.data.customerMobile)                      
  // };

  // Send via WhatsApp API
  // this.AspCheckinReportsService.sendWhatsAppMessage('serviceCompleted', messagePayload).subscribe(
  //   res => {
  //     console.log('WhatsApp message sent', res);
  //   },
  //   err => {
  //     console.error('Failed to send WhatsApp message', err);
  //   }
  // );
    this.openSideShow=false;
  }
  closePopup(){
    this.PopupOpen=false;
    this.openSideShow=false;
    this.isPopupOpen=false;
  }
  updateInfo() {
    // Ensure this.items is always an array
    const itemsArray = Array.isArray(this.items) ? this.items : [this.items];
   console.log("itemsArray4567890", itemsArray)
//    labourName;
// jobCardStatus: 0
// labourId;
// id: 0 
    // Transform items into expected structure
    const customerQuoteItems = itemsArray.map((item: any) => ({
      id: item['itemId'],
      jobCardStatus: 4,
      jobcardId: item['jobcardId']
    }));
    const labourQuoteItems = itemsArray.map(item => ({
      labourName: item.labourName || item.itemName || '', // adjust based on your actual field names
      jobCardStatus: 5,
      labourId: item.labourId || item.itemId || null,
      id: item.id || ' '
    }));
    
    const dataUpdate = {
      jobcardId: this.request.jobCard.id,
      customerQuoteItems, // Multiple items passed here
      customerQuoteId: this.quoteDetails['customerQuoteId'],
      labourQuoteItems
    };
  
    this.myJobCardsDetailsService.updateStatus(dataUpdate).subscribe(result => {
      if(result['code']== 200)
        window.location.reload();
    });
    this.PopupOpen=false;
    this.openSideShow=false;
  }
  
  
  getQuoteDetails() { 
    this.quoteDetails = [];
    const userKey = localStorage.getItem('spareUserKey');
    const garageKey = localStorage.getItem('garageKey');
    this.quoteFormArray.clear(); // reset form array
  
    this.aspQuotationDetailsService.getQuoteDetails(
      garageKey,
      this.request1.jobCard.customerQuoteId,
      this.request1.jobCard.id,
      userKey
    ).subscribe((result: any) => { 
      const res = result;
      this.quoteDetails = res.data;
      console.log(" amaksha", this.quoteDetails);
      this.items = [...(res.data.items || []), ...(res.data.labourQuoteItemResponses || [])];
      this.customerQuotation = res.data.items
        ? res.data.items.filter(item => item.jobCardStatus === 4 || item.jobCardStatus === 4)
        : [];
        this.selectedItemsLabourQuote = (res.data.labourQuoteItemResponses || []).filter(labour => labour.jobCardStatus === 4 || labour.jobCardStatus === '4');
        // this.selectedItemsLabourQuote = (this.data.labourQuoteItemResponses || []).filter(labour => labour.jobCardStatus === 3 || labour.jobCardStatus === '3');
        this.discountType = res.data.discountType;
        this.discountValue = res.data.discountValue;
        this.customerQuotation.forEach((item, index) => {
          const discountValue = item.discountType === 'rupees' ? item.discountValue : 0;
          const discountPercentage = item.discountType === 'percentage' ? item.discountValue : 0;
          const group = this.fb.group({
            discountValue: [discountValue],
            discountPercentage: [discountPercentage]
          });
                if(this.customerQuotation)
      {

        setTimeout(() => {
          const formArray = this.mainForm.get('quoteFormArray') as UntypedFormArray;

          if (formArray && formArray.controls?.length > 0) {
            formArray.controls.forEach((control, i) => {
              const discountPercentage = +control.get('discountPercentage')?.value || 0;
              const discountValue = +control.get('discountValue')?.value || 0;

              if (discountPercentage > 0) {
                this.onDiscountPercentageInput(i);
              } else if (discountValue > 0) {
                this.onDiscountValueInput(i);
              }
            });
          }
        }, 0);

      }
          this.quoteFormArray.push(group);
          group.patchValue({ discountValue, discountPercentage }, { emitEvent: false });
          setTimeout(() => this.calculateItemDiscountPreview(index), 0);
          group.valueChanges.subscribe(() => {
            this.calculateItemDiscountPreview(index);
          });
          
        });
        
        
        
  
      this.getQuoteGrandTotal();
    });
  }
  
  initializeDummyData() {
    this.quotationReceived = [
      { name: 'Lower Arm - LH', price: 1000, quantity: 1, selected: false, brand: 'Brand A', availability: 'In Stock', mrpUnit: 1200, mrpTotal: 1200, sellingPriceUnit: 1000, totalSellingPrice: 1000, discount: 0, partNumber: '12345' },
      { name: 'Lower Arm - RH', price: 1200, quantity: 2, selected: false, brand: 'Brand B', availability: 'In Stock', mrpUnit: 1300, mrpTotal: 1300, sellingPriceUnit: 1200, totalSellingPrice: 2400, discount: 5, partNumber: '54321' },
    ];

    this.quotationApproved = [
      { name: 'Suspension Kit', price: 3000, quantity: 1 }
    ];
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  openSidebar(item: any): void {
    this.sidebarOpen = true;
    this.itemDetails = item;
  }

  closeSidebar(): void {
    this.sidebarOpen = false;
  }



  updateTotalSellingPrice(): void {
    this.selectedItemsCount = this.quotationReceived.filter(item => item.selected).length;
    this.totalSelectedPrice = this.quotationReceived.reduce((acc, item) => item.selected ? acc + item.price * item.quantity : acc, 0);
  }

  approveQuote(): void {
  }

  getMakeImageUrl(make: string | undefined | null): string {
    if (!make) {
      console.warn('Car make is undefined or null. Returning default image.');
      return 'https://cube.getpitstop.com/assets/img/default.png'; // Ensure this URL points to a valid default image
    }
    const makeWithoutSpaces = make.toLowerCase().replace(/\s+/g, '');
    return `https://cube.getpitstop.com/assets/img/${makeWithoutSpaces}.png`;
  }


  shareOnWhatsApp(): void {
    if (!this.request) {
      // console.warn('Request object is undefined or null:', this.request);  
      alert('No job card data available to share.');
      return;
    }
  
    if (!this.request.jobCard) {
      // console.warn('Job card is missing:', this.request.jobCard); 
      alert('No job card data available to share.');
      return;
    }
    
  
    const jobCard = this.request.jobCard;
  
    const message = `
      👋 Hello ${jobCard.name},
      
      
      🛠 Your job card has been created successfully.
      
      📋 Job Card ID: ${jobCard.id}
      🚗 Odometer: ${jobCard.odometer}  
      📝 Registration Number: ${jobCard.registrationNumber}
      🏷 Make: ${jobCard.make}  
      🚙 Model: ${jobCard.model}  
      📅 Variant: ${jobCard.variant}  
      📆 MFG Year: ${jobCard.mfgYear || 0} 
      ⛽ Fuel: ${jobCard.fuelType} 
      🔑 VIN: ${jobCard.vin || ""} 
      
      We will soon send you a quotation for approval.
      
      Best regards,
      ${localStorage.getItem('spareSelectedGarageName') || 'Garage'}
    `;
  
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    // const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    alert('Your job card details have been shared on WhatsApp.');
  }


  fetchJobCardDetails(): void {
    this.aspLoadingService.show();
    const garageKey = localStorage.getItem('garageKey');
    console.log("this.jobcardId--",this.jobCardId);
    this.myJobCardsDetailsService.getJobCardDetails(this.bookingId , garageKey, this.jobCardId).subscribe(
      (result: any) => {
        this.aspLoadingService.hide();
  
        if (result && result.code === 200) {
          this.request = result.data;
          this.request1 = result.data;
          this.isGstDetailsPresent = this.request.isGstDetailsPresent;

          this.fetchPreFilledBooking();
          console.log("this.request.isGstDetailsPresent",this.request.isGstDetailsPresent);

          this.getQuoteDetails()
          // Check if request-id is present in the response
          const requestId = this.request?.jobCard?.requestId; // Update this path as per your actual response structure
          // const status = this.request?.jobCard?.jobcardStatus; 
          this.status = this.request?.jobCard?.jobcardStatus || '';  
          // Check if request-id is present in the response
          this.requestId = this.request?.jobCard?.requestId; // Update this path as per your actual response structure
          this.rateCardApplicable = this.request?.jobCard?.rateCardApplicable; // Update this path as per your actual response structure
          this.carSize = this.request?.jobCard?.carSize; // Update this path as per your actual response structure



       
        if(!this.invoiceOpenItem){
          this.loadComponentB(this.request?.jobCard); // Pass the request-id to Component B
        }
        } else {
          // console.warn('No "request-id" found in job card details');
        }
        
      },
      (error: HttpErrorResponse) => {
        this.aspLoadingService.hide();
        // console.error('Error fetching job card details:', error);
      }
    );
  }
  formatOrderDeliveryTime(confirmTime: string, deliveryTime: string) {
    try {
      const confirmDate = new Date(confirmTime.replace(" ", "T"));
      const deliveryDate = new Date(deliveryTime.replace(" ", "T"));
  
      if (isNaN(confirmDate.getTime()) || isNaN(deliveryDate.getTime())) {
        return '0 minutes';
        
      }
  
      const diffMs = deliveryDate.getTime() - confirmDate.getTime();
      const diffMins = Math.floor(diffMs / 60000);
  
      if (diffMins < 0) {
        return '0 minutes';
        
      }
  
      if (diffMins <= 180) {
        return `${diffMins} minutes`;
      } else {
        const hours = Math.floor(diffMins / 60);
        const minutes = diffMins % 60;
        return `${hours}H ${minutes} min`;
      }
  
    } catch (error) {
      return '0 minutes';
    }
  }
  // fetchMyRequest(): void {
  //   const spareUserKey = localStorage.getItem('spareUserKey');
  //   const garageKey = localStorage.getItem('garageKey');

  //   this.aspMyRequestService.myRequest(spareUserKey, garageKey).subscribe(
  //     result => {
  //       const res = JSON.parse(JSON.stringify(result));
  //       if (res.code === 200) {
  //         // Process the response data as needed
  //         console.log('My Request Data:', res.data);
  //       } else {
  //         console.warn('Error fetching My Request data:', res.message);
  //       }
  //     },
  //     (error: HttpErrorResponse) => {
  //       console.error('Error fetching My Request:', error);
  //     }
  //   );
  // loadComponentB(requestId: number) {
  //   // Create the factory for Component B
  //   const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AspRequestDetailsComponent);

  //   // Clear the container
  //   this.container.clear();

  //   // Add the component to the container
  //   this.container.createComponent(componentFactory);
  //   // Logic to dynamically load Component B and pass requestId
  // const componentRef = this.viewContainerRef.createComponent(AspRequestDetailsComponent);
  
  // // Pass the requestId to Component B
  // componentRef.instance.requestId = requestId;
  // }

  loadComponentB(jobCard): void {
    // this.container.clear(); // Just in case
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AspJobcardQuotationComponent);
    const componentRef = this.container.createComponent(componentFactory);
    const instance = componentRef.instance as AspJobcardQuotationComponent;
    instance.requestId = jobCard.requestId;
    instance.jobCard = jobCard;
  }

goBack(): void {
  this.location.back();
}

fetchPreFilledBooking(): void {
  // const registrationNumber = "registrationNumber";
  const garageKey = localStorage.getItem('garageKey');
  const registrationNumber = this.request.jobCard.registrationNumber;
  localStorage.setItem("registrationNumber", this.request.jobCard.registrationNumber);
  localStorage.setItem("selectedModel", this.request.jobCard.model);
  localStorage.setItem("variant", this.request.jobCard.variant);
  localStorage.setItem("selectedYear", this.request.jobCard.mfgYear);
  localStorage.setItem("fuelType", this.request.jobCard.fuelType);
  localStorage.setItem("vin", this.request.jobCard.vin);
  localStorage.setItem("selectedMake", this.request.jobCard.make);

  
  this.myJobCardsDetailsService.getPreFilledBooking(registrationNumber, garageKey).subscribe(
    res => {
      if (res && res.data) {
        // this.customer.name = res.data.name;
        // this.customer.mobile = res.data.mobile;
        // this.customer.email = res.data.email;
        // this.car.vin = res.data.vin;
        // this.car.engineNumber = res.data.engineNumber;
        this.showServiceHistory = true; 
      } else {
        this.showServiceHistory = false; 
      }
    },
    error => {
      console.error('Error fetching booking data:', error);
      this.showServiceHistory = false;
    }
  );
}
openServiceHistory(): void {
  // Dynamically create the component
  const factory = this.resolver.resolveComponentFactory(AspVehicleServiceHistoryComponent);
  const componentRef = this.historyContainer.createComponent(factory);

  // Access the instance and call the closeSidebar or similar method
  const serviceHistoryInstance = componentRef.instance as AspVehicleServiceHistoryComponent;
  serviceHistoryInstance.openSidebar(true);
  
}

sendFeedback() {
  this.checkInDetails();
  // console.log("customerName---",this.data.customerName);
  // console.log("garageName------",this.data.garageName);
  // const customerName = "Customer"; 
  // const garageName = "Autoverse Garage";
  const localBaseUrl = 'http://localhost:4200';
  
  const garageKey= localStorage.getItem('garageKey');
  const combinedPath = `${this.jobCardId}/${this.status}/${garageKey}`;
  const encodedPath = btoa(combinedPath);

  const feedbackLink = `${GlobalVariable.AUTOVERSE_WEB}/customer-feedback/${encodedPath} `
  // const feedbackLink = `${localBaseUrl}/customer-feedback/` + this.jobCardId + '/' + this.status;
  // Construct WhatsApp Message
    
  const message = `*🚗 Service Feedback Request*  

  Dear ${this.customerName}, 👋  
  
  Your car is ready for delivery! 🚗  
  
  We value your feedback to improve our services.  
  Kindly take a moment to share your experience by clicking the link below:  
  
  🔗 ${feedbackLink}  
  
  Thank you for choosing us! 😊  
  
  Regards, 
  *_${this.data.garageName}_*`;

const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');

  // Open WhatsApp with the pre-filled message
  // const whatsappUrl = `https://wa.me/?text=${message}`;
  // window.open(whatsappUrl, '_blank');
  // const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  // window.open(whatsappUrl, '_blank');
  //    const messagePayload = {
  //   v1: this.data.garageName,                        
  //   v2: '',                                 
  //   v3: this.customerName,                                   
  //   v4: this.request?.jobCard?.registrationNumber,               
  //   v5: '', 
  //   id: feedbackLink,
  //   to: String(this.data.customerMobile)                    
  // };

  // Send via WhatsApp API
  // this.aspCheckinReportsService.sendWhatsAppMessage('feedBack', messagePayload).subscribe(
  //   res => {
  //     console.log('WhatsApp message sent', res);
  //   },
  //   err => {
  //     console.error('Failed to send WhatsApp message', err);
  //   }
  // );
}
redirectToFeedback() {
  this.router.navigate(['asp-feedback']);
}
invoiceOpen(){
  this.sidebarOpenInvoice=true;
  this.openSideShow=false;
}
CloseSidebar(){
  localStorage.removeItem('invoiceOpen');
  if (this.onClose) {
    this.onClose();
  }
  this.sidebarOpenInvoice=false;
}
toggleSidebar() {
  this.isSidebarOpen = !this.isSidebarOpen;
}
clearSearch() {
  this.searchWord = '';

  this.filteredItems = [];
}
sidebarToggleSelectAllQuote() {
  
  this.selectAllQuote = !this.selectAllQuote;

  // Ensure customerQuotation is defined before looping
  if (Array.isArray(this.customerQuotation)) {
    this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);
  } else {
    console.error("Error: this.customerQuotation is undefined or not an array", this.customerQuotation);
  }
  if (Array.isArray(this.selectedItemsLabourQuote)) {
    this.selectedItemsLabourQuote.forEach(labour => {
      labour.selected = this.selectAllQuote;
    });
  } else {
    console.log('error select all labour');
  }

  // Ensure selectedItemsLabourQuote is defined before looping
  if (Array.isArray(this.selectedItemsLabourQuote)) {
    this.selectedItemsLabourQuote.forEach(labour => labour.selected = this.selectAllQuote);
  } else {
    console.error("Error: this.selectedItemsLabourQuote is undefined or not an array", this.selectedItemsLabourQuote);
  }
  console.log("this.customerQuotation---",this.customerQuotation);
  console.log("this.selectedItemsLabourQuote--",this.selectedItemsLabourQuote);
//   this.totallabourListNewSelectedPrice = this.selectedItemsLabourQuote?.reduce(
//     (sum, labour) => sum + (Number(labour.labourAmount) * Number(labour.quantity || 1)), 0
//   );
//   this.sparePartsTotalcreation = this.customerQuotation.reduce((total, quote) => 
//     total + (quote.sellingPrice * quote.quantity), 0
// );


  // Ensure selectedLabours is defined
  this.selectedLaboursCount = this.selectedLabours ? this.selectedLabours.length : 0;

  // Call other functions
  // this.labourList();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();



// this.anyItemSelected();
// this.toggleItemSelection();

}
ApprovedtoggleItemSelection(): void {
  this.selectedApprovedItemsCount = this.quotationapproved.filter(item => item.selected).length;
  this.totalSelectedApprovedPrice = this.quotationapproved
    .filter(item => item.selected)
    .reduce((total, item) => total + ((item.mrp - (item.mrp * item.sellingDiscount / 100)) * item.itemQuantity), 0);

  // Check if all items are selected, update selectAll accordingly
  this.selectAll = this.selectedApprovedItemsCount === this.quotationapproved.length;

  console.log("Selected Items Count:", this.selectedApprovedItemsCount);
  console.log("Total Selected Price:", this.totalSelectedApprovedPrice);

  this.updateSelectedItemsQuote();
  this.updateApprovedSelectedItems();
  this.anyItemSelected();
}
updateApprovedSelectedItems(): void {
  this.selectedApprovedItemsCount = this.quotationapproved.filter(item => item.selected).length;
  this.totalSelectedApprovedPrice = this.quotationapproved.filter(item => item.selected).reduce((total, item) => total+((item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity), 0);
  this.totalSelectedApprovedPrice = this.quotationapproved.filter(item => item.selected).reduce((total, item) => total+((item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity), 0);
  // this.selectedItemsCount=this.selectedLabours?.length+this.selectedItemsCountQuote
  // this.selectedLaboursCount=this.selectedLabours.length;
  // console.log("Selected Items Count:", this.selectedItemsCount);

}
toggleSelectAllQuote(): void {
  this.selectAllQuote = !this.selectAllQuote;
  this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);
  this.selectedItemsLabourQuote.forEach(labour => labour.selected=this.selectedLabourCount);
  this.selectedLaboursCount=this.selectedLabours.length;
  this.updateSelectedItemsQuote();
  this.anyItemSelected();
  this.toggleItemSelection();
}
toggleSelectAll(): void {
  this.selectAll = !this.selectAll;
  this.quotationreceived.forEach(item => item.selected = this.selectAll);
   this.updateSelectedItems();
}
updateSelectedItems(): void {
  // Ensure arrays exist
  const received = this.quotationreceived || [];
  const approved = this.quotationapproved || [];
  const labours = this.selectedLabours || [];
  const countQuote = this.selectedItemsCountQuote || 0;

  // Filter selected items
  const selectedReceivedItems = received.filter(item => item.selected);
  const selectedApprovedItems = approved.filter(item => item.selected);

  // Calculate total prices
  this.totalApprovedSelectedPrice = selectedApprovedItems.reduce((total, item) => {
    const discountedPrice = item.mrp - (item.mrp * item.sellingDiscount / 100);
    return total + (discountedPrice * item.itemQuantity);
  }, 0);

  this.totalSelectedPrice = selectedReceivedItems.reduce((total, item) => {
    const discountedPrice = item.mrp - (item.mrp * item.sellingDiscount / 100);
    return total + (discountedPrice * item.itemQuantity);
  }, 0);

  // Calculate total selected count
  this.selectedItemsCount = selectedReceivedItems.length + labours.length + countQuote;

  // Debug log
  console.log("Selected Received Items:", selectedReceivedItems.length);
  console.log("Selected Labours:", labours.length);
  console.log("Selected Count Quote:", countQuote);
  console.log("Final Selected Items Count:", this.selectedItemsCount);
}


isQuoteApproved(): boolean {
  return this.quotationapproved.length > 0;
}
// addItemToQuotation(item: any) {
//  console.log("addItemToQuotation",item);
//   // Find an existing item with the same partNumber
//   const existingItem = this.customerQuotation.find(quote => quote.partNumber === item.partNumber);

//   if (existingItem) {
    
//  console.log("existingItem",existingItem);
//     // If found, increase the quantity
//     existingItem.itemQuantity += 1;
//      } else {
//     // Otherwise, add the new item to the list
// const newItem = {
//   itemId: item.itemId,
//   itemName: item.name,
//   brand: item.brand,
//   partNumber: item.partNumber,
//   sellingPrice: item.mrp,
//   originalMrp: item.mrp, // <-- Needed for discount calculations
//   mrp: item.mrp,          // <-- This is mutable MRP used for calculation
//   hsnCode: item.hsnCode,
//   gstRate: item.gstRate,
//   quantity: 1,
//   selected: true,
//   edt: new Date(),
// };

//     this.customerQuotation.push(newItem);
//     console.log("newItem",newItem);
//     // this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);

//     const discountGroup = this.fb.group({
//       discountValue: [0],
//       discountPercentage: [0]
//     });
    
//     this.quoteFormArray.push(discountGroup);
    
//     // Immediately calculate sellingPrice to avoid null
//     this.recalculateMrpWithDiscount(this.customerQuotation.length - 1, discountGroup.value);
    
//     // Now subscribe to future changes
//     discountGroup.valueChanges.subscribe(discount => {
//       const itemIndex = this.customerQuotation.findIndex(q => q.partNumber === item.partNumber);
//       if (itemIndex !== -1) {
//         this.recalculateMrpWithDiscount(itemIndex, discount);
//       }
//     });
    
//   }
//   this.isSidebarOpen = false;
//   this.clearSearch();
//   this.toggleItemSelectionQuote();
//   this.updateSelectedItemsQuote();
//   this.updateSelectedLabourItems();
//   this.getQuoteGrandTotal();
  
// }
addItemToQuotation(item: any) {
  console.log("addItemToQuotation", item);

  // Find an existing item with the same partNumber
  const existingItem = this.customerQuotation.find(quote => quote.partNumber === item.partNumber);

  if (existingItem) {
    console.log("existingItem", existingItem);
    // If found, increase the quantity
    existingItem.itemQuantity += 1;

  } else {
    // Otherwise, add the new item to the list
    const newItem = {
      itemId: item.itemId,
      itemName: item.name,
      brand: typeof item.brand === 'object' ? item.brand.name : item.brand, // ✅ Normalize brand
      partNumber: item.partNumber,
      sellingPrice: item.mrp,
      originalMrp: item.mrp, // For discount calculations
      mrp: item.mrp,         // Mutable MRP used for calculation
      hsnCode: item.hsnCode,
      gstRate: item.gstRate,
      quantity: 1,
      selected: true,
      edt: new Date()
    };

    this.customerQuotation.push(newItem);
    console.log("newItem", newItem);

    const discountGroup = this.fb.group({
      discountValue: [0],
      discountPercentage: [0]
    });

    this.quoteFormArray.push(discountGroup);

    // Immediately calculate sellingPrice to avoid null
    this.recalculateMrpWithDiscount(this.customerQuotation.length - 1, discountGroup.value);

    // Subscribe to future changes
    discountGroup.valueChanges.subscribe(discount => {
      const itemIndex = this.customerQuotation.findIndex(q => q.partNumber === item.partNumber);
      if (itemIndex !== -1) {
        this.recalculateMrpWithDiscount(itemIndex, discount);
      }
    });
  }

  this.isSidebarOpen = false;
  this.clearSearch();
  this.toggleItemSelectionQuote();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
  this.getQuoteGrandTotal();
}

    updateItemTotal(index: number) {
      const discount = this.quoteFormArray.at(index).value;
      this.recalculateMrpWithDiscount(index, discount);
      this.updateSelectedItemsQuote();
    }

    recalculateMrpWithDiscount(index: number, discount: { discountValue: number; discountPercentage: number }) {
      const item = this.customerQuotation[index];
      const basePrice = item.originalSellingPrice || item.mrp || 0;
      const totalBasePrice = basePrice * item.quantity;
    
      let newSellingPrice = totalBasePrice;
    
      if (discount?.discountValue != null && +discount.discountValue > 0) {
        const value = Math.min(+discount.discountValue, totalBasePrice);
        newSellingPrice = totalBasePrice - value;
      } else if (discount?.discountPercentage != null && +discount.discountPercentage > 0) {
        const percent = Math.min(+discount.discountPercentage, 100);
        newSellingPrice = totalBasePrice - (totalBasePrice * percent / 100);
      }
    
      // Set per-item selling price (divide total by quantity)
      item.sellingPrice = item.quantity > 0 ? parseFloat((newSellingPrice / item.quantity).toFixed(2)) : 0;
    
      // Flag invalid discount if price goes below zero or discount too high
      item.isDiscountInvalid = newSellingPrice < 0 || 
        (discount.discountValue > totalBasePrice) || 
        (discount.discountPercentage > 100);
    
      this.getQuoteGrandTotal();
      this.updateSelectedItemsQuote();
      this.updateSelectedLabourItems();
    }
    
    
    


ApprovedtoggleSelectAll(): void {
  this.selectAll = !this.selectAll;
  this.quotationapproved.forEach(item => item.selected = this.selectAll);
  // console.log("this.selectedItemsCount-----------------",this.selectedItemsCount);
  this.updateApprovedSelectedItems();
  this.anyItemSelected();
  this.ApprovedtoggleItemSelection();
}
toggleItemSelection(): void {
  this.selectedItemsCount = this.quotationreceived.filter(item => item.selected).length;
  this.totalSelectedPrice = this.quotationreceived
    .filter(item => item.selected)
    .reduce((total, item) => total + ((item.mrp - (item.mrp * item.sellingDiscount / 100)) * item.itemQuantity), 0);

  // ✅ Check if all checkboxes are selected and update `selectAll`
  this.selectAll = this.selectedItemsCount === this.quotationreceived.length;

}
// updateSelectedItems(): void {
//   this.selectedItemsCount = this.quotationreceived.filter(item => item.selected).length;
//   this.totalApprovedSelectedPrice = this.quotationapproved.filter(item => item.selected).reduce((total, item) => total+((item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity), 0);
//   this.totalSelectedPrice = this.quotationreceived.filter(item => item.selected).reduce((total, item) => total+((item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity), 0);
//   // this.selectedItemsCount=this.selectedLabours?.length +this.selectedItemsCountQuote;
//   this.selectedItemsCount=this.selectedLabours.length +this.selectedItemsCountQuote;
//  console.log("this.selectedItemsCount",this.selectedItemsCount)
// }
// updateSelectedItemsQuote(): void {

//   this.selectedItemsQuote = this.customerQuotation.filter(quote => quote.selected);
//   this.selectedItemsCountQuote = this.customerQuotation.filter(quote => quote.selected).length;
//   console.log("123 items---",this.selectedItemsCountQuote);
  
//   this.selectedItemsCount1=(this.selectedItemsCountQuote || 0)+(this.selectedLabourLength || 0);
//   console.log("Items Length",this.selectedItemsCount1);
//   this.selectedItemsLabourQuotePrice=this.selectedItemsLabourQuote?.filter(quote => quote.selected)
//   .reduce((total, quote) => total + (quote.labourAmount *1), 0);
//   this.selectedLabourLength = this.selectedItemsLabourQuote?.filter(quote => quote.selected).length;
//   this.sparePartsTotal = this.customerQuotation
//     .filter(quote => quote.selected)
//     .reduce((total, quote) => total + (quote.sellingPrice * quote.quantity), 0);
//     console.log("totoaofkjfjfdf----",this.sparePartsTotal)
//   this.totalSelectedPriceQuoteTotal = this.sparePartsTotal +(this.selectedItemsLabourQuotePrice || 0);
//   this.customerQuotationPrice = this.sparePartsTotal +(this.selectedItemsLabourQuotePrice || 0);
//   this.selectedItemsCountTotal=(this.selectedLabourLength ) +(this.selectedItemsCountQuote);
//   console.log("456 labous------",this.selectedItemsCountTotal)
//  }

updateSelectedItemsQuote(): void {
  this.selectedItemsQuote = this.customerQuotation.filter(quote => quote.selected);
  this.selectedItemsCountQuote =  this.customerQuotation.filter(quote => quote.selected).length; // Ensure correct count
  console.log("this.customerQuotation--====",this.customerQuotation);
  this.sparePartsTotalcreation = this.selectedItemsQuote.reduce((total, quote) => 
      total + (quote.sellingPrice * quote.quantity), 0
  );

  this.sparePartsTotal = this.selectedItemsQuote.reduce((total, quote) => 
      total + (quote.sellingPrice * quote.quantity), 0
  );

  // Ensure this.selectedItemsCount is defined
  // this.selectedItemsCount = (this.selectedItemsCountQuote || 0)+ (this.selectedLabours.length || 0);

  this.selectedItemsCount = (this.selectedItemsCountQuote || 0) + (this.selectedLabourslength || 0);
  // console.log("this.sparePartsTotalcreation----",this.sparePartsTotalcreation);
  // console.log("==========================================================================")
  // console.log("this.totallabourSelectedPrice------",this.totallabourSelectedPrice);
  // // Update the total with selected labour
  // this.totalSelectedPriceQuote = this.sparePartsTotalcreation + (this.totallabourSelectedPrice || 0);
  
  // console.log("Selected totalSelectedPriceQuote-----:", this.totalSelectedPriceQuote);


  // console.log("Total Selected Parts Price:", this.sparePartsTotalcreation);
  this.getQuoteGrandTotal();
}


  
updateSelectedLabourItems(): void {
this.selectedLabours = this.selectedItemsLabourQuote?.filter(labour => labour.selected);
this.selectedLabourslength = this.selectedLabours?.length || 0;

console.log("this.selectedLaobours---",this.selectedLabourslength);


// ✅ Ensure total price includes updated labour costs
this.totalSelectedPriceQuote = Number(this.totallabourSelectedPrice) + Number(this.sparePartsTotalcreation || 0);
this.customerQuotationPrice = this.totalSelectedPriceQuote;


const totalItems = this.customerQuotation.filter(quote => quote.selected).length;
const totalLabourItems = this.selectedItemsLabourQuote?.filter(labour => labour.selected).length;
this.selectedItemsCount = totalItems + this.selectedLabourslength;
console.log("totalItems----",this.selectedItemsCount);
console.log("saikiran items--",this.selectedItemsCountQuote);
console.log("saikiran labour--",this.selectedLabourslength);
this.totallabourListNewSelectedPrice = this.selectedNewLabourSelected?.reduce(
  (sum, labour) => sum + (Number(labour.labourAmount) * Number(labour.quantity || 1)), 0
);

// ✅ Multiply labour amount by quantity
this.totallabourSelectedPrice = this.selectedLabours?.reduce(
  (sum, labour) => sum + (Number(labour.labourAmount) * Number(labour.quantity || 1)), 0
);
console.log("spapre Price---",this.selectedItemsLabourQuote);
this.totallabourListSelectedPrice = this.selectedItemsLabourQuote?.reduce(
  (sum, labour) => sum + (Number(labour.labourAmount) * Number(labour.quantity || 1)), 0
);
this.totalInvoicePrice = (this.sparePartsTotalcreation || 0) + (this.totallabourSelectedPrice || 0);
console.log("totalInvoicePrice----",this.totalInvoicePrice)
console.log("spapre Price---",this.sparePartsTotalcreation);

this.totallabourListSelectedPrice = this.selectedItemsLabourQuote.reduce(
  (sum, labour) => sum + (Number(labour.labourAmount) * labour.quantity || 0), 
  0
);
console.log("meghana",this.totallabourListSelectedPrice);

// --------------------------------Discount--------------------------------
console.log("this.discountType",this.discountType);
console.log("this.discountValue",this.discountValue);
// discouunt type and discount values
if (this.discountType === 'rupees') {
  this.calculatedDiscount = this.discountValue;
} else if (this.discountType === 'percentage') {
  this.calculatedDiscount = (this.totalInvoicePrice * this.discountValue) / 100;
}
console.log("this.calculatedDiscount---",this.calculatedDiscount);
// ------------------------------------------------------------------------


}
AddItems()
{
  this.isSidebarOpen = !this.isSidebarOpen;
  this.searchText = '';
  this.filteredItems = [];
}

sidebarToggleItemSelectionQuote(){
  this.toggleItemSelectionQuote();

}
openEditDialog(itemQuotes){
  this.itemQuote=[];
  this.itemQuote=itemQuotes;
  this.itemQuote['discountedPrice'] = this.calculateDiscountedPrice(itemQuotes.mrp, itemQuotes.discount);
  this.isPopupOpenEdit = true;
  this.selectedItemsCountQuote = 0;
  if (itemQuotes) {
    this.itemQuotesEdit = { ...itemQuotes };
   }
  // this.customerQuotation.forEach(quote => {
  //   quote.selected = false;
  // });
  // this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote=false);
}
calculateDiscountedPrice(mrp: number, discount: number): number {
  return mrp - (mrp * discount / 100);
}
decrementQuantity(quote: any): void {
  if (quote.quantity > 1) { 
    quote.quantity--;
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();
    this.updateSelectedItemsQuote();
    this.getQuoteGrandTotal();  
  }
}
calculateTotalQuotationPrice(): number {
  // Recalculate total price by summing up all items' total amounts
  return this.customerQuotation.reduce((sum, item) => sum + (item.mrp * item.itemQuantity), 0);
}
incrementQuantity(quote: any): void {
  quote.quantity++;
  this.customerQuotationPrice = this.calculateTotalQuotationPrice();
  this.updateSelectedItemsQuote();
  this.getQuoteGrandTotal();  
}
reloadApprovedQuotes() {
  const newApprovedItems = this.quotationreceived.filter(item => !this.quotationapproved.some(approved => approved.itemId === item.itemId));
  
  // Add only new items to the approved list
  this.quotationapproved.push(...newApprovedItems);
console.log("this.quotationapproved.-----------",this.quotationapproved);
  // Recalculate total approved price
  this.quoteApprovedPrice = this.quotationapproved.reduce((total, item) => 
    total + ((item.mrp - (item.mrp * item.sellingDiscount / 100)) * item.itemQuantity), 0);
}
toggleItemSelectionQuote(): void {
  if (Array.isArray(this.customerQuotation)) {
    this.selectAllQuote = this.customerQuotation.every(quote => quote.selected);
  
  } else {
    this.selectAllQuote = false;
  }
  // if (Array.isArray(this.selectedItemsLabourQuote)) {
  //   this.selectedItemsLabourQuote.forEach(labour => {
  //     labour.selected = labour.selected ? true : false;
  //   });

  //   this.selectedLabourCount = this.selectedItemsLabourQuote.filter(labour => labour.selected).length;
  // }
  //  else {
  //   this.selectAllQuote = false;
  //   this.selectedLabourCount = 0;
  // }
  // this.labourList();
  
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
  this.cdr.detectChanges();
}
toggleItemSelectionLabour(): void {
  if (Array.isArray(this.selectedItemsLabourQuote)) {
    this.selectAllQuote = this.selectedItemsLabourQuote.every(labour => labour.selected);
    this.selectedLabourCount = this.selectedItemsLabourQuote.filter(labour => labour.selected).length;
  } else {
    this.selectAllQuote = false;
    this.selectedLabourCount = 0;
  }

  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
  this.cdr.detectChanges();
}

openSidebar1(itemdata): void {
  // console.log('Item Data:', itemdata);
  this.itemDetails=[];
  this.itemDetails=itemdata;
  this.itemDetails.discountedPrice = this.calculateDiscountedPrice(itemdata.mrp, itemdata.discount);
  this.sidebarOpen = true;


  // this.itemDetails.brandName = itemdata.bidDetails?.[0]?.estimateItem?.Battery?.[0]?.brand;

  // this.sidebarOpen = true;
  

}
// updateSelectedLabourItems(): void {
//   this.selectedLabours = this.selectedItemsLabourQuote.filter(labour => labour.selected);
//   this.selectedLabourslength = this.selectedItemsLabourQuote.filter(labour => labour.selected).length;
//   // this.selectedItemsLabourQuote = this.selectedLabours;

//   // this.selectedItemsCount = this.selectedLabours.length;
//   this.totallabourSelectedPrice = this.selectedItemsLabourQuote.reduce((sum, labour) => {
//     return sum + (labour.labourAmount || 0);
//   }, 0);
//   // this.selectedLabourCount = this.selectedItemsLabourQuote.every(labour => labour.selected);
//   // this.selectedLabourCount=this.selectedLabourCount.length;
//   this.totalSelectedPriceQuote = this.totallabourSelectedPrice + (this.sparePartsTotal || 0);
//   this.customerQuotationPrice = this.totalSelectedPriceQuote;
//   this.selectedLaboursCount=this.selectedLabours.length || 0;
//   this.selectedItemsCount=this.selectedLaboursCount.length +this.selectedItemsCountQuote
//   console.log("total selected labour price-----------------", this.totallabourSelectedPrice); 
//  }
labourList() {
  const garageKey = localStorage.getItem('garageKey');
  console.log("garagekey", garageKey);

  if (garageKey) {
      this.aspRequestDetailsService.displayLabourList(garageKey,this.rateCardApplicable,this.carSize).subscribe(
          (result) => {
              const res = JSON.parse(JSON.stringify(result));
              if (res.code === 200) {
                  console.log("labourres", res);
                  console.log("this.selectedItemsLabourQuote labourlist----", this.selectedItemsLabourQuote);

                  if (!Array.isArray(this.selectedItemsLabourQuote)) {
                      this.selectedItemsLabourQuote = [];
                  }
console.log("selcted labour items---",this.selectedItemsLabourQuote);
                  // Ensure labours in selectedItemsLabourQuote remain selected in the list
                  this.fullLabourList = res.data.map((labour: any) => {
                      const existingItem = this.selectedItemsLabourQuote.find(
                          (selectedItem: any) => selectedItem.labourId === labour.labourId
                      );

                      return {
                          ...labour,
                          selected: !!existingItem, // Mark as selected if present in selectedItemsLabourQuote
                          quantity: existingItem?.quantity ?? 1, // Use existing quantity, otherwise default to 1
                      };
                  });

                  // Sorting: Move selected items to the top
                  this.fullLabourList.sort((a, b) => Number(b.selected) - Number(a.selected));

                  this.labourListData = [...this.fullLabourList]; // Copy sorted list to labourListData
                  console.log("Updated labourListData:", this.labourListData);
                  this. onLabourSelectionChange(this.selectedItemsLabourQuote);
                  this.updateSelectedLabourItems();
                  this.updateSelectedItemsQuote();
              }
          },
          (error) => {
              console.error('Error fetching labour list:', error);
          }
      );
  } else {
      console.warn('Garage key not found in localStorage.');
  }
}


invoiceOpen123(){
  this.side1235=true
}
openLabourEditSidebar(item: any = null) {
  this.isEditLabourSidebarOpen = true;
  // this.isAddLabour = item ? false : true;
  this.isSidebarOpen = false;
// console.log("sdjfjsdfjisdf")
  if (item) {
    this.selectedLabour = { ...item };
    this.labourName = this.selectedLabour.labourName;
    this.labourAmount = this.selectedLabour.labourAmount;
    this.labourId = this.selectedLabour.labourId;
    this.id = this.selectedLabour.id;

  } else {
    this.selectedLabour = { name: '', price: null };
  }
}
anyItemSelected() {
  return this.selectedLabourslength > 0;
}
anyItemSelectedQuote() {
  return this.selectedItemsCountQuote > 0;
}
onSearch(item: any) {
  if (!this.searchWord.trim()) {
    return;
  }
  const garageKey=localStorage.getItem('garageKey');
  const variantKey=this.request.jobCard['variantKey'];
  this.aspRequestDetailsService
    .searchItems(garageKey, this.searchWord,variantKey)
    .subscribe(
      (result) => {
        const res = JSON.parse(JSON.stringify(result));
        
        if (res.code === 200) {
          this.filteredItems = res.data;
          this.partNumber= res.data.map((item: any) => item.partNumber);
        } else {
          console.error('Search failed with code:', res.code);
        }
      },
      (error) => {
        console.error('Error during search:', error);
      }
    );
}
addLabourSidebar(){
  this.isAddLabour = !this.isAddLabour; 
  this.labourList();
  
  
}
labourRedirectSidebar()
{
  this.isAddLabour=false;
  this.selectedLabourCount=0;
  }
  toggleSelect() {
    this.selectAll = !this.selectAll;
  }
  onLabourSelectionChange(labour: any): void {
    if (!labour) {
      console.error('Labour object is undefined');
      return;
    }
  
    // Ensure labour is selected
    labour.selected = labour.selected || false;
  
    // ✅ Set default quantity to 1 if not already set
    if (!labour.quantity || labour.quantity < 1 || labour.quantity == '') {
      labour.quantity = 1;
    }
  
    // Sync the selected items list
    this.selectedItemsLabourQuote = this.labourListData.filter(l => l.selected);
  
    // ✅ Calculate total selected price including quantity
    this.totallabourListSelectedPrice = this.selectedItemsLabourQuote.reduce(
      (sum, labour) => sum + (Number(labour.labourAmount) * labour.quantity || 0), 
      0
    );
  
    console.log(this.selectedItemsLabourQuote);
    console.log("this.selectedlabourprice----", this.totallabourListSelectedPrice);
  
    // ✅ Update the selected labour count
    this.selectedLabourCount = this.selectedItemsLabourQuote.length;
    console.log("selectedLabourCount---",this.selectedLabourCount);
  
    // ✅ Calculate total price
    this.totalSelectedPriceQuote1 = this.selectedItemsLabourQuote.reduce(
      (sum, item) => sum + (Number(item.labourAmount) * item.quantity || 0), 
      0
    );
  
    // Update UI
    // this.updateSelectedItemsQuote();
    // this.updateSelectedLabourItems();

    
  }
closeLabourEditSidebar() {
  this.isEditLabourSidebarOpen = false;
  this.selectedLabour = { labourName: '', labourAmount: null };
  // this.islaboursiLabour=false;
}
onCheckboxChange(labour: any, event: Event): void {
  if (!labour) {
    console.error('Labour object is undefined');
    return;
  }
  labour.selected = (event.target as HTMLInputElement).checked;
  this.updateSelectedLabourItems();
  this.updateSelectedItemsQuote(); // Sync after updating labour
}
openSkipConfirmation(){
  this.showSkipConfirmation = true;
}
closeSkipConfirmation(): void {
  this.showSkipConfirmation = false;
}
confirmSkip(): void {
  this.showSkipConfirmation = false;
  this.isAddLabour = false;
}
openPopUp(){
  this.showCancelConfirmation = true;
  this.isAddLabour = false;
}
closeCancelPopup(): void {
  this.showCancelConfirmation = false;
}
openPopup(): void {
  this.isPopupOpen = true;
  this.showSkipConfirmation = false;
  this.isAddLabour = false;
  this.CloseSidebarQuote();
  this.submitData();
  this.CloseSidebar(); 
  this.gstDetails = false;
  // this.gstside
}

openPopUpGst() {
  this.gstDetails = true;
}
// submitData() {
//     // Filter selected items
//     this.selectedItems = this.customerQuotation.filter(quote => quote.selected);


//     // Generate random 7-digit ID for items with null or undefined `itemId`
//     this.selectedItems.forEach(item => {
//       if (!item.itemId) {
//         item.itemId = Math.floor(1000000 + Math.random() * 9000000);
//            }
//     });

//     const selectedPartNumbers = this.filteredItems.map(item => item.partNumber);
//     let labour = [];
//     console.log("submitData of Labour Quantity ------",this.selectedItemsLabourQuote);
//     if (this.selectedItemsLabourQuote && this.selectedItemsLabourQuote.length > 0) {
//       labour = this.selectedItemsLabourQuote.map(labour => ({
//         labourId: labour.labourId ,
//         labourName: labour.labourName,
//         labourAmount: labour.labourAmount || 0, // Ensure labourAmount is not undefined
//         customerQuoteId: this.request.jobCard.customerQuoteId,
//         itmQty:labour.quantity,
//       }));
//     }

//     // Extract GST details similar to createJobCard()
//   const gstDetails = {
//     gstNumber: this.cgf.gstNumber?.value || null,
//     addressLine1: this.af.addressLine1?.value || null,
//     addressLine2: this.af.addressLine2?.value || null,
//     city: this.af.city?.value || null,
//     pincode: this.af.pincode?.value || null,
//     state: this.cgf.state?.value || null,
//     companyName: this.cgf.businessName?.value || null,
//   };
//   console.log("gstDetails payload---",gstDetails);

//   const isGstDetailsEmpty = Object.values(gstDetails).every(value => value === null);
//   const customerGstDetails = isGstDetailsEmpty ? null : {
//     ...gstDetails,
//     address: `${gstDetails.addressLine1 || ''}, ${gstDetails.addressLine2 || ''}, ${gstDetails.city || ''} - ${gstDetails.pincode || ''}`,
//   };
//      const cleanData = {
 
//       quoteId: this.request.jobCard.customerQuoteId,
//       garageKey: localStorage.getItem('garageKey'),
//       jobcardId: this.request?.jobCard?.id,
//       quoteVersion: 1,
//       gstNumber: "",
//       billingAddress: "",
//       shippingAddress: "",
//       discountType: this.discountType,            
//       discountValue: this.discountValue,      
  
//       customerQuoteItems: this.selectedItems.map(item => ({
//         id: item.itemId,
//         partName: item.itemName,
//         itmQty: item.quantity,
//         partNumber: item.partNumber,
//         brand: item.brand,
//         sellingPrice: item.sellingPrice,
//         hsnCode:item.hsnCode,
//         gstRate:item.gstRate

//       })),
//       labourQuoteItems: labour, // Use the correctly mapped labour array
//       customerGstDetails: customerGstDetails
//       // registrationNumber:  this.request?.jobCard?.registrationNumber?? null,
//     };


//     // Submit the data via the service
//     this.myJobCardsDetailsService.submitData1(cleanData).subscribe(
//       response => {
//         console.log("submitData1-create-invoice-sidebar",response)
//         this.resData = response['data'];
//         this.dataid = response['data'].id;
//         this.invoiceId = response['data'].invoiceId
//         localStorage.removeItem('gstToggle');
        

//        },
//       error => {
//         console.error('Error occurred:', error);
//       }
//     );

//   // else {
//   //   this.submitDataUpdate();
//   // }
// }


submitData() {
  this.selectedItems = this.customerQuotation.filter(quote => quote.selected);

  this.selectedItems.forEach(item => {
    if (!item.itemId) {
      item.itemId = Math.floor(1000000 + Math.random() * 9000000);
    }
  });

  const selectedPartNumbers = this.filteredItems.map(item => item.partNumber);

  let labour = [];
  console.log("submitData of Labour Quantity ------", this.selectedItemsLabourQuote);

  if (this.selectedItemsLabourQuote && this.selectedItemsLabourQuote.length > 0) {
    labour = this.selectedItemsLabourQuote.map(labour => ({
      labourId: labour.labourId,
      labourName: labour.labourName,
      labourAmount: labour.labourAmount || 0,
      customerQuoteId: this.request.jobCard.customerQuoteId,
      itmQty: labour.quantity,
    }));
  }

  const gstDetails = {
    gstNumber: this.cgf.gstNumber?.value || null,
    addressLine1: this.af.addressLine1?.value || null,
    addressLine2: this.af.addressLine2?.value || null,
    city: this.af.city?.value || null,
    pincode: this.af.pincode?.value || null,
    state: this.cgf.state?.value || null,
    companyName: this.cgf.businessName?.value || null,
  };

  const isGstDetailsEmpty = Object.values(gstDetails).every(value => value === null);
  const customerGstDetails = isGstDetailsEmpty ? null : {
    ...gstDetails,
    address: `${gstDetails.addressLine1 || ''}, ${gstDetails.addressLine2 || ''}, ${gstDetails.city || ''} - ${gstDetails.pincode || ''}`,
  };

  // ✅ NEW BLOCK: Generate itemsWithDiscount like 1st function
  const discountFormArray = this.mainForm?.get('quoteFormArray')?.value || [];

const itemsWithDiscount = this.selectedItems.map((item, index) => {
  const discountEntry = discountFormArray[index] || {};
  let discountType = '';
  let discountValue = 0;

   if (discountEntry.discountPercentage && discountEntry.discountPercentage > 0) {
    discountType = 'percentage';
    discountValue = discountEntry.discountPercentage;
  }

  return {
    id: item.itemId,
    partName: item.itemName,
    itmQty: item.quantity,
    partNumber: item.partNumber,
    brand: item.brand,
    // sellingPrice: item.mrp, 
    sellingPrice: item.originalMrp ?? item.mrp, // ✅ USE ORIGINAL
    mrp: item.originalMrp ?? item.mrp,
    hsnCode: item.hsnCode,
    gstRate: item.gstRate,
    discountType:"percentage",
    discountValue:discountValue
  };
});



  const cleanData = {
    quoteId: this.request.jobCard.customerQuoteId,
    garageKey: localStorage.getItem('garageKey'),
    jobcardId: this.request?.jobCard?.id,
    quoteVersion: 1,
    gstNumber: "",
    billingAddress: "",
    shippingAddress: "",
    discountType: this.discountType,
    discountValue: this.discountValue,
    customerQuoteItems: itemsWithDiscount, // ✅ replaced with itemsWithDiscount
    labourQuoteItems: labour,
    customerGstDetails: customerGstDetails
  };

  console.log("clean Data--------",cleanData);

  this.myJobCardsDetailsService.submitData1(cleanData).subscribe(
    response => {
      console.log("submitData1-create-invoice-sidebar", response);
      this.resData = response['data'];
      this.dataid = response['data'].id;
      this.invoiceId = response['data'].invoiceId;
      localStorage.removeItem('gstToggle');
    },
    error => {
      console.error('Error occurred:', error);
    }
  );
}



// toggleSlider(): void {
//   const garageKey = localStorage.getItem('garageKey');
//   // this.nonStop = isChecked;
//   this.showGstColumn =  0 ;

//   const cleanData1 = {
//     invoiceId: this.invoiceId,
//     showGstColumn: this.showGstColumn,
//     garageKey: garageKey,
//   };

//   this.aspInvoiceDetailsService.showGst(cleanData1).subscribe({
//     next: (result: any) => {
//       this.data = result;
//       this.toggle = result.data;
//       console.log("GST column updated:", this.showGstColumn);
//       console.log("this.toggle--", this.toggle);
//       console.log("this.data---", this.data);
//       // this.invoiceDetails();

//       // ✅ Store toggle status in localStorage
//       // localStorage.setItem('gstToggle', this.toggle);
//       // this
//     },
//     error: err => {
//       console.error("Error updating GST column:", err);
//     }
//   });
// }
submitDataUpdate() {
  // if (this.quoteId) {
  
  // Create a clean data object with only the required fields
  this.selectedItems = this.customerQuotation.filter(quote => quote.selected)
  this.selectedItems.forEach(item => {
    this.item=item.bidId;
  });
  
  const cleanData1 = {
    
    bidId: this.item,
    garageKey: localStorage.getItem('garageKey'),
    items: this.selectedItems.map(item => ({
      id: item.itemId,
      part_name: item.itemName,
      partNumber: item.partNumber,
      sellingPrice: item.mrp
    })),
    quoteId: this.request.jobCard.customerQuoteId,
    registrationNumber: this.request?.jobCard?.registrationNumber ?? null,
    requestId: this.id,
    userKey:localStorage.getItem('spareUserKey'),
  };
  
  this.aspRequestDetailsService.submitDataUpdate(cleanData1).subscribe(response => {
    this.resData=response['data']
    console.error('response11:',response );
  });
}
CloseSidebarQuote(): void {
  this.sidebarOpenQuote = false;  
}
onLabourSearch(): void {
  const query = this.searchText?.toLowerCase();

  if (query) {
    // ✅ Always filter from fullLabourList to preserve original data
    this.labourListData = this.fullLabourList.filter(item =>
      item.labourName?.toLowerCase().includes(query)
    );
  } else {
    // ✅ Reset to full list
    this.labourListData = [...this.fullLabourList];
  }
}


clearLabourSearch(): void {
  this.searchText = '';
  this.labourListData = [...this.fullLabourList];  // Reset view
}

addLabour() {
  console.log(this.ld.labourAmount.value);
  const updatedLabourName = this.ld.labourName.value;
  const updatedLabourAmount = this.ld.labourAmount.value;
  const garageKey = localStorage.getItem('garageKey');

  this.aspRequestDetailsService.addLabourList(garageKey, updatedLabourName, updatedLabourAmount,this.rateCardApplicable,this.carSize)
    .subscribe((result) => {
      const res = JSON.parse(JSON.stringify(result));
      if (res.code === 200) {
        console.log("addLabour--", res);
        const newLabour = {
          labourName: updatedLabourName,
          labourAmount: updatedLabourAmount,
          selected: true, 
          quantity: 1,
          id: res.data?.id,
          labourId : res.data?.labourId,
          
        };
        this.labourListData.unshift(newLabour);
        this.selectedItemsLabourQuote.unshift(newLabour);
        this.labourList();
        this.updateSelectedItemsQuote();
        this.updateSelectedLabourItems();
        this.toastr.success("Labour Added Successfully");
        this.ngOnInit();
      }
      else{
        this.toastr.error("Duplicate Names are not allowed")
      }

      this.closeLabourEditSidebar();
      this.ngOnInit();
    });
}
saveLabour(): void {
  console.log("Labour Name:", this.ld.labourName.value);
  console.log("Labour Amount:", this.ld.labourAmount.value);

  const updatedLabourName = this.ld.labourName.value;
  const updatedLabourAmount = this.ld.labourAmount.value;
  const garageKey = localStorage.getItem('garageKey');
  const rateCardType = this.rateCardApplicable ? this.rateCardApplicable : 'Default';
  console.log("this.rateCardType",rateCardType);
  const carSize = this.carSize ?? null;
const status = 1;
  this.aspRequestDetailsService
      .editLabour(this.id, this.labourId, garageKey, updatedLabourName, updatedLabourAmount,rateCardType,carSize,status)
      .subscribe(
          (result) => {
              console.log('API Response:', result);
              const res = JSON.parse(JSON.stringify(result));

              if (res.code === 200) {
                  console.log('Labour edited successfully:', res);
                  this.toastr.success("Labour saved Successfully");

                  let labourExists = false;
                  
                  this.selectedItemsLabourQuote = this.selectedItemsLabourQuote.map(item => {
                      if (item.id === this.id) {  // Ensure matching by correct ID
                          labourExists = true;
                          return {
                              ...item,
                              labourName: updatedLabourName,
                              labourAmount: updatedLabourAmount,
                              selected: true // Ensure it stays selected
                          };
                      }
                      return item;
                  });

                  // If the labour does not exist, add it as selected
                  if (!labourExists) {
                      this.selectedItemsLabourQuote.push({
                          id: this.id,
                          labourName: updatedLabourName,
                          labourAmount: updatedLabourAmount,
                          selected: true
                      });
                  }

                  console.log("Updated selectedItemsLabourQuote:", this.selectedItemsLabourQuote);

                  // Refresh the labour list to reflect changes
                  this.labourList();
              } else {
                  console.warn('Unexpected response code:', res.code);
              }
          },
          (error) => {
              console.error('Error editing labour:', error);
          }
      );

  this.closeLabourEditSidebar();
}




// toggleSelectItem(): void {

//   this.selectedItemsLabourQuote = this.labourListData.filter(item => item.selected);
//   this.totalSelectedPriceQuote1 = this.selectedItemsLabourQuote.reduce(
//     (sum, item) => sum + (item.labourAmount || 0),0);
//    this.isAddLabour = false;
//    this.getQuoteGrandTotal();
// }


// toggleSelectItem(): void {
//   if (Array.isArray(this.labourListData)) {
//     this.labourListData.forEach(labour => {
//       if (labour.selected) {
//         // Only add if it's not already in selectedItemsLabourQuote
//         const alreadySelected = this.selectedItemsLabourQuote.some(item => item.labourId === labour.labourId);
//         if (!alreadySelected) {
//           this.selectedItemsLabourQuote.push(labour);
//         }
//       }
//     });
//   }
  

//   // Ensure quantity is at least 1
//   this.selectedItemsLabourQuote.forEach(labour => {
//     if (!labour.quantity || labour.quantity == 0) {
//       labour.quantity = 1;
//     }
//   });
//   // console.log("selectedItemsLabourQuote---",this.selectedItemsLabourQuote)
//   this.selectedItemsLabourQuote = this.labourListData.filter(item => item.selected);
//   this.totalSelectedPriceQuote1 = this.selectedItemsLabourQuote.reduce(
//     (sum, item) => sum + (item.labourAmount || 0),0);
//   // console.log('Selected Items:', this.selectedItemsLabourQuote);
//   // console.log('Total Selected Price:', this.totalSelectedPriceQuote1);
//   this.isAddLabour = false;
//   this.updateSelectedItemsQuote();
//   this.updateSelectedLabourItems();
//   this.getQuoteGrandTotal();

// }
toggleSelectItem(): void {
  if (!Array.isArray(this.fullLabourList)) return;

  // Filter selected labours and ensure quantity is at least 1
  this.selectedItemsLabourQuote = this.fullLabourList
    .filter(labour => labour.selected)
    .map(labour => {
      if (!labour.quantity || labour.quantity === 0) {
        labour.quantity = 1;
      }
      return labour;
    });

  // Calculate total selected labour amount
  this.totalSelectedPriceQuote1 = this.selectedItemsLabourQuote.reduce(
    (sum, item) => sum + (item.labourAmount || 0),
    0
  );

  this.isAddLabour = false;

  // Update the relevant states
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
  this.getQuoteGrandTotal();
  this.clearLabourSearch();
}

closeAll(): void{
  this.isAddLabour = false;
  this.isEditLabourSidebarOpen = false;
  this.sidebarOpenQuote = false; 
  this.gstDetails = false;
}
save(): void {
  const index = this.customerQuotation.findIndex(i => i.partNumber === this.itemQuote['partNumber']);

   // If the item exists, update it
   if (index !== -1 ) {
     this.itemQuotesEdit=this.up.unitprice.value
       // Update the item in the list with the new unit price and recalculate total amount
       this.customerQuotation[index].mrp =Number(this.up.unitprice.value);
       this.customerQuotation[index].sellingPrice =Number(this.up.unitprice.value);
       this.customerQuotation[index].totalAmount = this.up.unitprice.value * this.itemQuote['quantity'];
       }
         // Recalculate the total quotation price
   this.customerQuotationPrice = this.calculateTotalQuotationPrice();
   // Close the popup after saving
   this.closePopupEdit();
   this.updateSelectedItemsQuote();
   this.updateSelectedLabourItems();
   this.getQuoteGrandTotal();
 }
closePopupEdit(): void {
  this.isPopupOpenEdit = false;
}
  @ViewChild('dynamicContainer1', { read: ViewContainerRef }) container1!: ViewContainerRef;
  loadorderQuote(id) {
    const factory = this.resolver.resolveComponentFactory(AspInvoiceDetailsComponent);
    const componentRef = this.container1.createComponent(factory);
    const componentBInstance = componentRef.instance as AspInvoiceDetailsComponent;
    this.closePopup();
    componentBInstance.resId(id);
    this.isPopupOpen=false;
  }
navigateToDetails(id: string) {
  console.log('Navigating with ID:', id);
  this.router.navigate(['/invoice-details'], { queryParams: {"id": id, "jobcardId":this.request?.jobCard?.id,"QuoteId":this.request1.jobCard.customerQuoteId}})
  this.isPopupOpen=false;
  this.sidebarOpenInvoice=false;
}

toggle() {
  this.isOpen = !this.isOpen;
}

getQuoteGrandTotal(){

  let partsTotal = 0;
  console.log("saikiran customer Quotation---",this.customerQuotation);
  
  if(this.customerQuotation){
    console.log("this.customerQuotation123",this.customerQuotation)
    console.log("this.selectedItemsLabourQuote123",this.selectedItemsLabourQuote)
    partsTotal = this.customerQuotation?.reduce((sum, item) => sum + (item.sellingPrice * item.quantity),0);
  }

  let labourTotal = 0;
  if(this.selectedItemsLabourQuote){
    labourTotal = this.selectedItemsLabourQuote?.reduce((sum, item) => sum + (Number(item.labourAmount) * item.quantity),0);
  }
  this.quoteGrandTotal = partsTotal + labourTotal;
}
// Example usage

createNewItems(){
  this.isSidebarOpen=false;
  this.newItem=!this.newItem;
}
createItemSidebar(){
  this.newItem= false;
  this.newItems=!this.newItems;
  this.isSidebarOpen=false;
}
onSubmit() {
     if (this.itemForm.invalid) {
    Object.keys(this.itemForm.controls).forEach(field => {
      const control = this.itemForm.get(field);
      control?.markAsTouched({ onlySelf: true });
      control?.updateValueAndValidity(); // Ensure validation messages appear
    });

    this.scrollToFirstInvalidField();
    return;
  }

  console.log('Form submitted successfully', this.itemForm.value);

  if (this.itemForm.valid) {
    console.log('Form Submitted createNewItem', this.itemForm.value);
    const cleanData1 = {
      "garageKey": localStorage.getItem('garageKey'),
      "garageName": localStorage.getItem('spareSelectedGarageName'),
      "userName": localStorage.getItem('spareSelectedGarageName'),
      "userRole":localStorage.getItem('userType'),
      "partName": this.itemForm.value['itemName'],
      "partNumber":this.itemForm.value['partNumber'],
      "mrp": (this.itemForm.value.unitPrice / 100).toFixed(2),
      "gstRate": this.itemForm.value['gst'],
      "brandName":this.itemForm.value['brand'],
      "hsnCode": this.itemForm.value['hsn'],
      "make": this.request?.jobCard?.make,
      "model": this.request?.jobCard?.model,
      "variant":this.request?.jobCard?.variant,
      "rowKey": this.request?.jobCard?.rowKey,
      "variantKey": this.request?.jobCard?.variantKey
    };
  
    // Call the API with updated data
    this.aspCustomerQuoteService.createNewItem(cleanData1).subscribe(response => {
      const res = JSON.parse(JSON.stringify(response));
      console.log("res123456789",res);
      this.originalData=res.data;
      const transformedData = {
        ...this.originalData, 
        brand:this.originalData.brandName,
        itemName: this.originalData.partName, 
        itemId: undefined, 
        quantity: 1, 
        sellingPrice:this.originalData.mrp
      };
      this.customerQuotation.push(transformedData);
      console.log("this.customerQuotation",this.customerQuotation);
      // this.customerQuotationListCount = this.customerQuotation.length
      // console.log('Item added successfully:', this.customerQuotationListCount);
      this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);  


      // this.customerQuotationCount=this.customerQuotation.length;
      this.isSidebarOpen = false;
      this.clearSearch();
      this.updateSelectedItemsQuote();
      this.getQuoteGrandTotal();
      this.itemForm.reset();
    }
  )
  }
  this.newItems=false;
}
scrollToFirstInvalidField() {
  const firstInvalidControl: HTMLElement = document.querySelector(
    ".ng-invalid.ng-touched"
  ) as HTMLElement;

  if (firstInvalidControl) {
    firstInvalidControl.scrollIntoView({ behavior: "smooth", block: "center" });
    firstInvalidControl.focus(); // Optional: Focus on the field
  }
}

incrementLabourQuantity(quote: any): void {
  if (quote.quantity >= 1) {
    quote.quantity++;
  }

  // ✅ Recalculate labour price and update UI
  this.labourQuotationPrice = this.calculateTotalLabourPrice();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
  this.getQuoteGrandTotal();  
  this.cdr.detectChanges();
}

decrementLabourQuantity(quote: any): void {
  if (quote.quantity > 1) { // ✅ Prevents quantity from going below 1
    quote.quantity--;
  }

  // ✅ Recalculate labour price and update UI
  this.labourQuotationPrice = this.calculateTotalLabourPrice();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
  this.getQuoteGrandTotal();  
  this.cdr.detectChanges();
}


calculateTotalLabourPrice(): number {
  if (!Array.isArray(this.selectedItemsLabourQuote) || this.selectedItemsLabourQuote.length === 0) {
    return 0; // Return 0 if the array is undefined or empty
  }

  return this.selectedItemsLabourQuote.reduce(
    (sum, item) => sum + (Number(item.labourAmount) * Number(item.quantity || 1)),
    0
  );
}

// ==================GST 1ST-SIDEBAR-CODE===============

closeGstSlider() {
  this.gstDetails = false;  
}

// skipForNow() {
//   this.gstDetails = false;  
//   this.showGstSecondSlider = false;
// }

selectGstOption(isGstAvailable: boolean) {
  this.hasGst = isGstAvailable; 
}

continueNextStep() {
  if (this.hasGst !== null) {
      this.gstDetails = false;
  }
  if (this.hasGst) {
        this.showGstSecondSlider = true;  
      }
}
continueNextStep1(){
  this.isPopupOpen = true;
  this.CloseSidebarQuote();
  this.submitData();
  this.CloseSidebar(); 
  this.gstDetails = false;
}
closeGstDetails(){
  this.gstDetails = false
}


// ================= GST-2ND SLIDER============
 // Function to validate GST input

// Function to show the second slider when "Yes" is selected
// continueNextStep() {
//   if (this.hasGst) {
//     this.showGstSecondSlider = true;  // Show second slider
//   }
// }

// Close Second Slider
closeSecondSlider() {
  this.showGstSecondSlider = false;
  this.gstDetails = true;
}

// Proceed to Next Step
proceedToNextStep(): void {
  if (this.gstNumber.length === 15) {
    this.customerGstForm.patchValue({ gstNumber: this.gstNumber });
    this.openBusinessSlider();
  }
}



openBusinessSlider() {
  this.showBusinessInfoSlider = true;
  this.showGstSecondSlider = false;  // Hide GST slider

}

closeBusinessSlider() {
  this.showBusinessInfoSlider = false;
  this.showGstSecondSlider = true;
}

validateGstInput() {
  const control = this.gstNumberform.get('gstNumber');
  const value = control?.value?.toUpperCase() || '';
  control?.setValue(value, { emitEvent: false });
  if (this.gstNumber.length > 15) {
    this.gstNumber = this.gstNumber.substring(0, 15);
    console.log("gstNumber---",this.gstNumber);
}
}
// =========stats-selection======
openStateSlider(): void {
  this.stateSliderOpen = true;
 this.fetchStates();
}

closeStateSlider(): void {
  this.stateSliderOpen = false;
}

fetchStates(): void {
  this.myJobCardsDetailsService.getStateList().subscribe(
    (response) => {
      if (response.code === 200) {
        this.stateData = response.data;
        this.filteredStates = [...this.stateData]; // Ensure filteredStates has full objects
      } else {
        console.warn('Error fetching states:', response.message);
      }
    },
    (error) => {
      console.error('API Error while fetching states:', error);
    }
  );
}

filterStates(): void {
  if (!this.searchText) {
    this.filteredStates = [...this.stateData];
  } else {
    this.filteredStates = this.stateData.filter(state =>
      state.name.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }
}
clearStateSearch(): void {
  this.searchText = '';
  this.filteredStates = [...this.stateData];
}

selectState(state: any): void {
  this.selectedState = state.name; // just the name as string
  console.log("Selected state ----", this.selectedState);

  this.customerGstForm.patchValue({ state: this.selectedState });
  this.stateSliderOpen = false;

  console.log("Form value after patch ----", this.customerGstForm.value);
}



// ===============gst address slide-sidre==================
openAddressSlider() {
  if (this.customerGstForm.get('businessName')?.invalid || this.customerGstForm.get('state')?.invalid) {
    this.customerGstForm.get('businessName')?.markAsTouched();
    this.customerGstForm.get('state')?.markAsTouched();
    return;
  }

  // Proceed if valid
  console.log("Proceeding to address slider...");
  this.showBusinessInfoSlider = false;
  this.showAddressSlider = true;

}

// Close Address Slider
closeAddressSlider() {
  this.showAddressSlider = false;
  this.showBusinessInfoSlider = true;
}

saveAddressDetails() {
  if (this.addressForm.valid) {
    const addressDetails = this.addressForm.value;

    this.showAddressSlider = false;
    // this.customerDetailsANDcarDetails = true;
    // this.jobCardDetails = false;
    if (this.request?.isGstDetailsPresent !== true) {
      this.submitData();
    }

    console.log('✅ Address saved:', addressDetails);
  } else {
    console.warn('❌ Address form is invalid:', this.addressForm.errors);
    this.addressForm.markAllAsTouched();
  }
}
cretaeInvoicePopUP(){
  this.isPopupOpen = true;
  this.showSkipConfirmation = false;
  this.isAddLabour = false;
  this.CloseSidebarQuote();
  this.submitData();
  this.CloseSidebar(); 
  this.gstDetails = false;
}
// =============================== EXTRA DISCOUNT-BOTTOM-SHEET=======================
openExtraDiscountBottomSheet() {
  this.showExtraDiscountBottomSheet = true;
}

closeExtraDiscountBottomSheet() {
  this.showExtraDiscountBottomSheet = false;
}

setDiscountType(type: 'rupees' | 'percentage') {
  this.discountType = type;
}

// saveExtraDiscount() {
//   console.log('Extra Discount Applied:', {
//     type: this.discountType,
//     value: this.discountValue
//   });
//   this.closeExtraDiscountBottomSheet();
// }
saveExtraDiscount() {
  if (this.discountType === 'rupees') {
    this.calculatedDiscount = this.discountValue;
  } else {
    this.calculatedDiscount = (this.totalInvoicePrice * this.discountValue) / 100;
  }
this.showExtraDiscountBottomSheet = false;
}
toggleInfoPopup() {
  this.showInfoPopup = !this.showInfoPopup;
}
getDiscountAmount(type: string): number {
  if (!this.totalInvoicePrice) return 0;
  if (type === 'rupees') {
    return this.discountValue;
  } else {
    return (this.discountValue / 100) * this.totalInvoicePrice;
  }
}

getDiscountPercentage(type: string): number {
  if (!this.totalInvoicePrice) return 0;
  if (type === 'percentage') {
    return this.discountValue;
  } else {
    return (this.discountValue / this.totalInvoicePrice) * 100;
  }
}

// calculateDiscountPreview(index: number) {
//   const totalAmount = this.customerQuotation[index]?.totalAmount || 0;

//   if (this.discountType === 'rupees') {
//     this.discountInRupees = this.discountValue || 0;
//     this.discountInPercent = totalAmount
//       ? (this.discountInRupees / totalAmount) * 100
//       : 0;
//   } else {
//     this.discountInPercent = this.discountValue || 0;
//     this.discountInRupees = totalAmount
//       ? (this.discountInPercent / 100) * totalAmount
//       : 0;
//   }
// }
calculateDiscountPreview(index: number) {
  const totalAmount = this.totalInvoicePrice || 0;
  console.log("this.customer without Index------",totalAmount);
  console.log("this.totalAmount-----", this.customerQuotation[index]);

  // Check if discountValue is greater than totalAmount
  this.isDiscountInvalid = false;
  if ((this.discountType === 'rupees' && (this.discountValue || 0) > totalAmount) ||
  (this.discountType === 'percentage' && (this.discountValue || 0) > 100)) {
this.isDiscountInvalid = true;
}


  if (this.discountType === 'rupees') {
    this.discountInRupees = this.discountValue || 0;
    this.discountInPercent = totalAmount
      ? (this.discountInRupees / totalAmount) * 100
      : 0;
  } else {
    this.discountInPercent = this.discountValue || 0;
    this.discountInRupees = totalAmount
      ? (this.discountInPercent / 100) * totalAmount
      : 0;
  }
}
 // =========================BELOW CODE IS FOR SEARCH BY PART-NO AND PART NAME WHILE CREATING ITEM MANUALLY============================
  toggleTopSearchBar() {
  this.searchActive = !this.searchActive;
   this.searchText = '';
  this.suggestions = [];

  // Reset form only if search is being closed
  if (!this.searchActive) {
    this.itemForm.reset(); // Clear all auto-filled form fields
  }
}


    isFirstSuggestion(suggestion: string, index: number): boolean {
        // Check if it's the first suggestion and if it matches preSearchValue
        let preSearchValue=localStorage.getItem('preSearchValue');
        return index === 0 && preSearchValue === suggestion['value'];
    }
    sortSuggestionsByRelevance(suggestions: { value: string, type: string }[], searchText: string): { value: string, type: string }[] {
    const typePriority = {
        brand: 4,
        category: 3,
        partName: 2,
        partNumber: 1,
    };

    return suggestions?.sort((a, b) => {
        const relevanceA = this.getRelevance(a.value, searchText) + typePriority[a.type];
        const relevanceB = this.getRelevance(b.value, searchText) + typePriority[b.type];

        return relevanceB - relevanceA; 
    });
}
getRelevance(suggestion: string, searchText: string): number {
    if (suggestion?.toLowerCase() === searchText?.toLowerCase()) {
        return 3; 
    } else if (suggestion?.toLowerCase().startsWith(searchText?.toLowerCase())) {
        return 2; 
    } else if (suggestion?.toLowerCase().includes(searchText?.toLowerCase())) {
        return 1; 
    } else {
        return 0; 
    }
}
 private clearLocalStorage(){
        sessionStorage.removeItem('sparePartsDetails');
        localStorage.removeItem('vehicleType');
        // localStorage.removeItem('newMake');
        // localStorage.removeItem('newModel');
        // localStorage.removeItem('newYear');
        // localStorage.removeItem('newVariant');
        // localStorage.removeItem('newVariantKey');
        // localStorage.removeItem('newRowKey');
        localStorage.removeItem('isShippingCharges');
        localStorage.removeItem('prepayUpiDiscount');
        // localStorage.removeItem('vehicleData');
        // localStorage.removeItem('selectedModel');
        // localStorage.removeItem('selectedYear');
        // localStorage.removeItem('variant');
        // localStorage.removeItem('selectedFuel');
        // localStorage.removeItem('variantKey');
        // localStorage.removeItem('rowKey');
        localStorage.removeItem('selectedSparesList');
        localStorage.removeItem('preSearchValue');
    };
         toggleSearch() {
          this.isSearchOpen = !this.isSearchOpen;
        this.isInputVisible = !this.isInputVisible;
        if (this.isInputVisible) {
          setTimeout(() => {
            const input = document.querySelector('.SearchInput') as HTMLInputElement;
            if (input) {
              input.focus();
            }
          }, 0);
        }
      }
      onPartNumberClick(partNumber: string): void {
  this.searchText = partNumber;
  this.filterSuggestions();
}

filterSuggestions(): void {
  console.log('Filtering for:', this.searchText);
  if (this.searchText && this.searchText.length >= 3) {
    const rowKey = localStorage.getItem('rowKey');
    const variantKey = localStorage.getItem('variantKey');
    const universal = false;

    this.searchSuggestionService.getSearchSuggestions(rowKey, this.searchText, universal, variantKey)
      .subscribe((result: any) => {
        console.log('API response:', result);
        this.suggestions = [];

        if (result?.data?.brands?.length)
          this.suggestions.push(...result.data.brands.map((value: string) => ({ value, type: 'brand' })));

        if (result?.data?.categories?.length)
          this.suggestions.push(...result.data.categories.map((value: string) => ({ value, type: 'category' })));

        if (result?.data?.partNames?.length)
          this.suggestions.push(...result.data.partNames.map((value: string) => ({ value, type: 'partName' })));

        if (result?.data?.partNumbers?.length)
          this.suggestions.push(...result.data.partNumbers.map((value: string) => ({ value, type: 'partNumber' })));

        console.log('Suggestions after parsing:', this.suggestions);

        this.suggestions.reverse();
        this.suggestions = this.sortSuggestionsByRelevance(this.suggestions, this.searchText);
      });
  } else {
    this.suggestions = [];
  }
}

selectSuggestion(suggestion: { value: string; type: string }): void {
  this.searchText = suggestion.value;
  this.suggestions = [];

  // If needed, you can do something based on type:
  if (suggestion.type === 'partNumber') {
    // Load item or navigate
    console.log('Selected Part Number:', suggestion.value);
  }
}
onPartSelected(partNumber: string) {
  if (!partNumber) return;

  // Set input box to selected part number
  this.searchText = partNumber;

  this.suggestions = [];

  let garageKey = localStorage.getItem('garageKey');
  this.aspProductDetailsService.productDetails(garageKey, 'part-number', partNumber).subscribe({
    next: (res: any) => {
      if (res.code === 200 && res.data) {
        const product = res.data;

        this.itemForm.patchValue({
          itemName: product.name || '',
          partNumber: product.partNumber || '',
          brand: product.brand?.name || '',
          unitPrice: product.sellingPrice || product.mrp || '',
           hsn: product.hsnCode || '',  
          // gst:product.gstRate * 100 || '',
        });
         // Convert gstRate decimal to percentage and assign to selectedGst
        this.selectedGst = product.gstRate ? Math.round(product.gstRate * 100) : null;
        this.addItemToQuotation(product);
      } else {
        this.toastr.error('Item details not found.');
      }
    },
    error: (err) => {
      console.error('Error fetching product details:', err);
      this.toastr.error('Item details not found.');
    }
  });
}

onItemNameInput(value: string) {
  clearTimeout(this.searchTimeout);

  if (value && value.length >= 2) {
    this.searchTimeout = setTimeout(() => {
      this.myJobCardsDetailsService.searchB2BLineItem(value).subscribe((res: any) => {
        this.itemSuggestions = res?.response?.body?.items || [];
        this.showSuggestionList = true;
      });
    }, 300);  // debounce time
  } else {
    this.itemSuggestions = [];
    this.showSuggestionList = false;
  }
}

selectItem(item: any) {
  this.itemForm.patchValue({ itemName: item.name });
  this.showSuggestionList = false;
  console.log('Selected item:', item);
}

// hideSuggestions() {
//   setTimeout(() => {
//     this.showSuggestionList = false;
//   }, 200);
// }

showSuggestions() {
  if (this.itemSuggestions.length > 0) {
    this.showSuggestionList = true;
  }
}
  // =========================END OF CODE  FOR SEARCH BY PART-NO AND PART NAME WHILE CREATING ITEM MANUALLY============================

// ============item level discount====================
calculateItemDiscountPreview(index: number): void {
  const quote = this.customerQuotation[index];
  const formGroup = this.quoteFormArray.at(index) as UntypedFormGroup;

  const discountValue = Number(formGroup.get('discountValue')?.value || 0);
  const discountPercentage = Number(formGroup.get('discountPercentage')?.value || 0);

  const basePrice = quote.originalSellingPrice || quote.mrp || 0;
  const quantity = quote.quantity || 1;
  const totalBasePrice = basePrice * quantity;

  // Reset invalid flag
  quote.isDiscountInvalid = false;

  // Validate discount limits
  if (discountValue > totalBasePrice || discountPercentage > 100) {
    quote.isDiscountInvalid = true;
    // Optionally, don't apply discount if invalid
    quote.sellingPrice = basePrice; 
    return;
  }

  let totalDiscount = discountValue;
  if (discountValue === 0 && discountPercentage > 0) {
    totalDiscount = (discountPercentage / 100) * totalBasePrice;
  }

  // Calculate per item discount
  const perItemDiscount = totalDiscount / quantity;

  // Calculate final selling price per item
  quote.sellingPrice = parseFloat((basePrice - perItemDiscount).toFixed(2));

  this.getQuoteGrandTotal();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
}




// getControlValue(index: number, controlName: string): boolean {
//   return this.quoteFormArray.at(index).get(controlName)?.value > 0;
// }
getControlValue(index: number, controlName: string): any {
  const controlGroup = this.quoteFormArray.at(index);
  if (!controlGroup) return null; // Avoid undefined access

  const control = controlGroup.get(controlName);
  return control ? control.value : null;
}



// onDiscountValueInput(index: number) {
//   const group = this.quoteFormArray.at(index);
//   console.log('Before patchValue:', group.value);
//   if (+group.get('discountValue')?.value > 0) {
//     group.patchValue({ discountPercentage: 0 }, { emitEvent: false });
//     console.log('After patchValue:', group.value);
//   }
//   this.calculateItemDiscountPreview(index);
// }

onDiscountValueInput(i: number) {
  const control = this.mainForm.get(['quoteFormArray', i]) as UntypedFormGroup;
  const value = +control.get('discountValue')?.value || 0;

  // Clear percentage field
  control.get('discountPercentage')?.setValue(0, { emitEvent: false });

  const item = this.customerQuotation[i];
  const mrp = (+item.mrp || 0)* (item.quantity);
  const originalMrp = item.originalMrp ?? item.mrp ?? 0;

  // Calculate percentage from value
  let discountPercentage = mrp > 0 ? (value / mrp) * 100 : 0;
  discountPercentage = parseFloat(discountPercentage.toFixed(2)); // round to 2 decimal places

  control.get('discountPercentage')?.setValue(discountPercentage, { emitEvent: false });

  item.discountValue = Math.round(value); // round off to nearest integer
  item.discountType = value > 0 ? 'rupees' : null;
  item.isDiscountInvalid = value > mrp;

  if (!item.isDiscountInvalid) {
    this.recalculateMrpWithDiscount(i, {
      discountValue: item.discountValue,
      discountPercentage,
    });
  }
}



onDiscountPercentageInput(i: number) {
  const control = this.mainForm.get(['quoteFormArray', i]) as UntypedFormGroup;
  let discountPercentage = +control.get('discountPercentage')?.value || 0;
  discountPercentage = parseFloat(discountPercentage.toFixed(2)); // round to 2 decimal places

  const item = this.customerQuotation[i];
  const mrp = (+item.mrp || 0) * (item.quantity);
  let discountValue = discountPercentage > 0 ? (mrp * discountPercentage) / 100 : 0;
  discountValue = Math.round(discountValue); // round to nearest integer

  control.get('discountValue')?.setValue(discountValue, { emitEvent: false });

  item.discountValue = discountValue;
  item.discountType = discountPercentage > 0 ? 'percentage' : null;
  item.isDiscountInvalid = discountPercentage > 100;

  // console.log("onDiscountPercentageInput edit quotation:", this.customerQuotation);

  if (!item.isDiscountInvalid) {
    this.recalculateMrpWithDiscount(i, {
      discountValue,
      discountPercentage,
    });
  }
}




  
}
